import { h } from 'preact';
import PropTypes from 'prop-types';

import { landToElement } from '../../../../utils/land-to-element';
import { getLoginUrl } from '../../../../utils/build-urls';
import { getLabel } from '../../../../labels/labelling-service';
import { IconArrowLink, IconClose, IconEdit } from '../../1-foundation/icons/icons';
import { modifierList as iconsModifiersList } from '../../1-foundation/icons/props-list';
import Cta from '../../2-atoms/cta/cta';

const handleCtaClick = (htmlId) => {
  landToElement.set({ elementId: htmlId });
};

const loginUrl = getLoginUrl(window.location.href);

const LoginCard = ({ htmlId, iconsColor, loginCardText, onClose }) => {
  const ctaId = `${htmlId}-accedi`;

  return (
    <div className="c-login-card c-login-card--in-rail">
      <a className="c-login-card__content" id={ctaId} href={loginUrl} onClick={() => handleCtaClick(htmlId)}>
        <div className="c-login-card__text">
          <IconEdit modifiers={[iconsColor, 'mix', 'xlarge', 'edit']} />
          {loginCardText}
        </div>
        <Cta
          modifiers={['no-outline']}
          tag="span"
          append={<IconArrowLink modifiers={['arrow-navigation', 'arrow-link', 'c-primary']} />}
        >
          {getLabel('parsely.login.enter')}
        </Cta>
      </a>
      <button className="c-login-card__close" type="button" onClick={onClose}>
        <IconClose modifiers={[iconsColor, 'navigation', 'close']} />
      </button>
    </div>
  );
};

LoginCard.propTypes = {
  iconsColor: PropTypes.oneOf(iconsModifiersList).isRequired,
  onClose: PropTypes.func,
  loginCardText: PropTypes.string,
  htmlId: PropTypes.string.isRequired,
};

export default LoginCard;
